import { render, staticRenderFns } from "./OverallDisclaimers.vue?vue&type=template&id=6154bbbf&scoped=true&"
import script from "./OverallDisclaimers.vue?vue&type=script&lang=js&"
export * from "./OverallDisclaimers.vue?vue&type=script&lang=js&"
import style0 from "./OverallDisclaimers.vue?vue&type=style&index=0&id=6154bbbf&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6154bbbf",
  null
  
)

export default component.exports